<template>
  <form class="main-modal" @submit.prevent="addMaterial" novalidate>
    <div class="main-modal__title">
      <p>
        {{
        modalType === "edit"
        ? $t("materials.updateMaterial")
        : $t("materials.newMaterial")
        }}
      </p>
    </div>

    <!-- <div
      class="form-item"
      :class="{ 'error-input': errors.has('title') }"
      :data-error="errorsHandler.title || $t('errors.required')"
    >
      <label>{{ $t("materials.title") }}</label>
      <input
        type="text"
        v-validate="'required|max:32'"
        data-vv-as="field"
        name="title"
        class="form-input"
        v-model="material.name.original"
        @input="checkLength"
        data-materialOriginal
      />
    </div>-->

    <div class="main-form__box">
      <span class="main-form__label">{{ $t("materials.title") }}:</span>
      <label>
        <input
          class="main-form__input"
          type="text"
          v-validate="'required|max:32'"
          data-vv-as="field"
          name="title"
          v-model="material.name.original"
          @input="checkLength"
          data-material-original
        />
      </label>
    </div>

    <div class="main-form__box">
      <span class="main-form__label">SKU:</span>
      <label>
        <input
          class="main-form__input"
          type="text"
          v-validate="'required|max:32'"
          data-vv-as="field"
          name="shortTitle"
          v-model="material.name.short"
          @input="checkShortLength"
          data-material-short
        />
      </label>
    </div>

    <!-- <div
      class="form-item"
      :class="{ 'error-input': errors.has('shortTitle') }"
      :data-error="errorsHandler.shortTitle || $t('errors.required')"
    >
      <label>{{ $t("materials.shortTitle") }}</label>
      <input
        type="text"
        v-validate="'required|max:32'"
        data-vv-as="field"
        name="shortTitle"
        class="form-input"
        v-model="material.name.short"
        @input="checkShortLength"
        data-materialShort
      />
    </div>-->

    <div class="main-form__box">
      <span class="main-form__label">{{ $t("materials.icon") }}:</span>
      <!-- <label> -->
      <v-select
        :onChange="setIcon"
        :options="getMaterialIcons"
        label="name"
        v-model="defaultIcon"
        :clearable="false"
      >
        <template slot="option" slot-scope="option">
          <img :src="option.path" width="20px" />
          {{ option.name }}
        </template>
      </v-select>
      <!-- </label> -->
    </div>

    <!-- <div class="form-item">
      <label>{{ $t("materials.icon") }}</label>
      <v-select
        :onChange="setIcon"
        :options="getMaterialIcons"
        label="name"
        v-model="defaultIcon"
        :clearable="false"
      >
        <template slot="option" slot-scope="option">
          <img :src="option.path" width="20px" />
          {{ option.name }}
        </template>
      </v-select>
    </div>-->

    <div class="main-form__box">
      <span class="main-form__label">{{ $t("materials.price") }}:</span>
      <label>
        <input
          class="main-form__input"
          type="number"
          min="0"
          v-validate="'required'"
          data-vv-as="field"
          name="required_field"
          v-model="material.price"
          data-material-price
        />
      </label>
    </div>

    <!-- <div
      class="form-item"
      :class="{ 'error-input': errors.has('required_field') }"
      :data-error="errorsHandler.price || $t('errors.required')"
    >
      <label>{{ $t("materials.price") }}</label>
      <input
        type="number"
        min="0"
        v-validate="'required'"
        data-vv-as="field"
        name="required_field"
        class="form-input"
        v-model="material.price"
        data-materialPrice
      />
    </div>-->
    <div class="main-form__buttons main-form__buttons_center">
      <span
        @click="$emit('toggleAddModal')"
        class="main-button main-button_cancel"
      >{{ $t("global.cancel") }}</span>
      <button
        type="submit"
        :class="{
          disabled: !checkIsValid,
        }"
        :disabled="!checkIsValid"
        class="main-button main-button_success"
      >{{ $t("global.save") }}</button>
    </div>
  </form>
</template>

<script>
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'AddMaterial',
    props: ['id', 'materialId'],
    components: {
        vSelect,
    },
    data() {
        return {
            load: false,
            errorsHandler: {
                price: '',
                shortTitle: '',
                title: '',
            },
        }
    },
    watch: {
        addNewModal(v) {
            if (v === false) this.clearErrors()
        },
    },
    computed: {
        ...mapGetters({
            material: 'materials/getMaterial',
            modalType: 'materials/getModalType',
            getMaterialIcons: 'materials/getMaterialIcons',
            getModalType: 'materials/getModalType',
            defaultIcon: 'materials/getDefaultIcon',
            addNewModal: 'materials/addModalGetters',
            status: 'materials/getRequestStatus',
        }),
        checkIsValid() {
            if (
                this.material.name.original === ''
        || this.material.name.original === null
            ) {
                return false
            }

            if (this.material.name.short === '' || this.material.name.short === null) {
                return false
            }

            if (this.material.price === '' || this.material.price === null) {
                return false
            }

            return true
        },
    },
    methods: {
        ...mapActions({
            add: 'materials/add',
            edit: 'materials/edit',
            fetch: 'materials/fetch',
            fetchMaterialIcons: 'materials/fetchMaterialIcons',
        }),
        addMaterial() {
            this.$validator.validate().then(async (valid) => {
                if (this.isValid(valid) && !this.isEditModal()) this.add(this.id)
                else if (this.isValid(valid) && this.isEditModal()) this.edit({ serviceId: this.id, materialId: this.material.id })
                else this.handleErrors()

                if (valid) this.$emit('toggleAddModal')
            })
        },
        setIcon(v) {
            this.material.icon = v.id
        },
        isEditModal() {
            return this.modalType === 'edit'
        },
        isValid(v) {
            return v
        },
        handleErrors() {
            if (this.material.price === '') this.errorsHandler.price = this.$t('materials.enterPrice')
            if (this.material.name.short === '') this.errorsHandler.shortTitle = this.$t('materials.enterShortTitle')
            if (this.material.name.original === '') this.errorsHandler.title = this.$t('materials.enterTitle')
        },
        checkLength() {
            const { length } = this.material.name.original
            if (length >= 32 && length !== 0) this.errorsHandler.title = this.$t('materials.titleMaxSize')
            else if (length === 0) this.errorsHandler.title = this.$t('materials.enterTitle')
        },
        checkShortLength() {
            const { length } = this.material.name.short
            if (length >= 32 && length !== 0) this.errorsHandler.shortTitle = this.$t('materials.titleMaxSize')
            else if (length === 0) this.errorsHandler.shortTitle = this.$t('materials.enterShortTitle')
        },
        clearErrors() {
            this.errors.items = []
        },
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";

// form input {
//   border-radius: 8px;
//   background-color: #ffffff;
//   border: 1px solid #e0e0e0;
//   font-family: "SFUIDisplay-Regular";
//   font-size: 14px;
//   color: #61422d;
//   padding-left: 20px;
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   -webkit-transition: 0.5s;
//   transition: 0.5s;
//   max-width: 100%;
//   outline: none;
//   margin: 3px 0 11px;
//   height: 30px !important;
// }

// h2 {
//   font-size: 20px;
//   color: #71bd4a;
//   font-family: "SFUIDisplay-Medium";
//   text-align: center;
//   margin: 0;
//   padding: 20px 0 0;
// }

// .form {
//   padding: 25px;
//   width: 300px;

//   &-item {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//   }
// }
</style>

<style>
/* .v-select .dropdown-toggle {
  padding: 0 !important;
  margin: 3px 0 11px !important;
  border-radius: 8px !important;
}

.v-select input {
  height: 30px !important;
} */

.v-select {
  background-color: var(--bg-color) !important;
  color: var(--menu-text-color);
}
.v-select .dropdown-toggle {
  border: 1px solid var(--border-color) !important;
}

.v-select .selected-tag {
  color: var(--menu-text-color);
}

.dropdown-menu {
  background-color: var(--bg-color) !important;
}

.dropdown-menu a {
  display: flex;
  align-items: center;
  color: var(--menu-text-color) !important;
}

.highlight,
.active,
.leave-active {
  background-color: var(--bg-color3) !important;
}
.dropdown-menu img {
  margin-right: 16px;
}

.dropdown-menu a:hover {
  background-color: var(--bg-color3) !important;
}

.highlight a {
  background-color: var(--bg-color3) !important;
}
</style>
